import { useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { Trans, useTranslation } from "react-i18next";
import { cn } from "../../../utils/classnames";
import { createTypographyHelper } from "../../../utils/typography";
import { useSelector, useDispatch } from "react-redux";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import { DownloadLargeIcon } from "../../../components/icons";

const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/visa-icon.svg";
const PricingBannerImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/pricing/pricing-banner.jpg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jcb-icon.svg";
const diners_club_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/diners-club-icon.svg";
const amex_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/amex-icon.svg";
const discover_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/discover-icon.svg";
const maestro_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/maestro-icon.svg";

const Pricing = () => {
  const dispatch = useDispatch();
  const page_name = "cms-pricing";
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  const cmspage_state = useSelector((state) => state.cmspage);
  const { loading } = cmspage_state;
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();

  return (
    <FrontLayout>
      {loading ? showLoading(true) : closeLoading(true)}
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto tw:font-hanken-grotesk">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(86.88deg,#000000_-1.88%,rgba(40,42,45,0.3)_6.14%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0"></div>
          <img
            src={PricingBannerImage}
            alt="Pricing Banner"
            className="tw:w-full tw:h-[430px] tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t("Pricing")}
            </div>
          </div>
        </div>
        <div className="tw:my-[45px] tw:lg:my-[72px]">
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:px-5 tw:lg:px-[82px]">
            <div className="tw:min-w-[430px] tw:text-[#282828] tw:font-semibold tw:text-lg tw:leading-[25px]">
              {t("PricingPage.PriceLists.Label")}
            </div>
            <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-3 tw:mt-[22px] tw:lg:mt-0">
              <a href="https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/pricing/TLF-Pricelist-EN.pdf" target="_blank" className="tw:flex-col tw:lg:w-[300px] tw:h-[102px] tw:flex tw:items-center tw:justify-center tw:gap-4 tw:border tw:rounded-md tw:!text-[#333333] tw:!no-underline">
                <DownloadLargeIcon color="#282828" size={13} />
                {t("Download Price List EN")}
              </a>
              <a href="https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/pricing/TLF-Pricelist-JP.pdf" target="_blank" className="tw:flex-col tw:lg:w-[300px] tw:h-[102px] tw:flex tw:items-center tw:justify-center tw:gap-4 tw:border tw:rounded-md tw:!text-[#333333] tw:!no-underline">
                <DownloadLargeIcon color="#282828" size={13} />
                {t("Download Price List JP")}
              </a>
            </div>
          </div>

          <div className="tw:h-[1px] tw:w-full tw:bg-[#F1F1F1] tw:my-12" />

          {/* Payment Methods */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:px-5 tw:lg:px-[82px] tw:mt-[45px] tw:lg:mt-[27px]">
            <div className="tw:min-w-[430px] tw:text-[#282828] tw:font-semibold tw:text-lg tw:leading-[25px]">
              {t("PricingPage.PaymentMethods.Label")}
            </div>
            <div className="tw:mt-[22px] tw:lg:mt-0">
              <div
                className={cn(
                  "tw:text-[#333333] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("PricingPage.PaymentMethods.Description1")}
              </div>
              <div className="tw:flex tw:items-center tw:gap-5 tw:mt-4">
                <img alt="img" src={visa_icon} className="tw:max-w-full tw:h-auto" />
                <img alt="img" src={jcb_icon} className="tw:max-w-full tw:h-auto" />
                <img alt="img" src={diners_club_icon} className="tw:max-w-full tw:h-auto" />
                <img alt="img" src={amex_icon} className="tw:max-w-full tw:h-auto" />
                <img alt="img" src={discover_icon} className="tw:max-w-full tw:h-auto" />
                <img alt="img" src={maestro_icon} className="tw:max-w-full tw:h-auto" />
              </div>
              <div
                className={cn(
                  "tw:text-[#333333] tw:leading-[18.5px] tw:lg:leading-[20px] tw:mt-[22px] tw:lg:mt-[26px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans i18nKey="PricingPage.PaymentMethods.Description2" components={{ strong: <strong />, u: <u /> }} />
              </div>
            </div>
          </div>

          <div className="tw:h-[1px] tw:w-full tw:bg-[#F1F1F1] tw:my-12" />

          {/* Booking Conditions Section */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:px-5 tw:lg:px-[82px] tw:mt-[45px] tw:lg:mt-[27px]">
            <div className="tw:min-w-[430px] tw:text-[#282828] tw:font-semibold tw:text-lg tw:leading-[25px]">
              {t("PricingPage.BookingConditions.Label")}
            </div>
            <div className="tw:mt-[22px] tw:lg:mt-0">
              <div className="tw:text-[#282828] tw:text-[18px] tw:lg:text-[22px] tw:leading-[24px] tw:lg:leading-[26px] tw:font-libre-caslon-display">
                {t("PricingPage.BookingConditions.General.Title")}
              </div>
              <div className="tw:h-[1px] tw:bg-[#D9D9D9] tw:my-4 tw:w-12" />
              <div
                className={cn(
                  "tw:text-[#282828] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <div>{t("PricingPage.BookingConditions.General.Description")}</div>
                <ul className="tw:list-disc">
                  <li>{t("PricingPage.BookingConditions.General.Point1")}</li>
                  <li>{t("PricingPage.BookingConditions.General.Point2")}</li>
                  <li>{t("PricingPage.BookingConditions.General.Point3")}</li>
                  <li>{t("PricingPage.BookingConditions.General.Point4")}</li>
                  <li>{t("PricingPage.BookingConditions.General.Point5")}</li>
                  <li>{t("PricingPage.BookingConditions.General.Point6")}</li>
                </ul>
              </div>
              <div className="tw:text-[#282828] tw:text-[18px] tw:lg:text-[22px] tw:leading-[24px] tw:lg:leading-[26px] tw:font-libre-caslon-display tw:mt-9 tw:lg:mt-[45px]">
                {t("PricingPage.BookingConditions.AdditionalTerms.Title")}
              </div>
              <div className="tw:h-[1px] tw:bg-[#D9D9D9] tw:my-4 tw:w-12" />
              <div
                className={cn(
                  "tw:text-[#282828] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <div>{t("PricingPage.BookingConditions.AdditionalTerms.Description")}</div>
                <ul className="tw:list-disc">
                  <li>{t("PricingPage.BookingConditions.AdditionalTerms.Point1")}</li>
                  <li>{t("PricingPage.BookingConditions.AdditionalTerms.Point2")}</li>
                  <li>{t("PricingPage.BookingConditions.AdditionalTerms.Point3")}</li>
                  <li>{t("PricingPage.BookingConditions.AdditionalTerms.Point4")}</li>
                  <li>{t("PricingPage.BookingConditions.AdditionalTerms.Point5")}</li>
                  <li>{t("PricingPage.BookingConditions.AdditionalTerms.Point6")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};

export default Pricing;
